export interface Part {
    cabinetType: string;
    id: string;
    partId: string;
    part_id?: string;
    partName: string;
    part_name?: string;
}

export enum HardwareType {
    RUNNER = 3,
}

export interface Hardware {
    id?: string;
    insert_id?: number;
    hardware_id?: number;
    hardwareId?: string;
    quantity?: string;
    conditional_type?: string;
    conditional_value?: string;
    hardware_type?: string;
    hardware_name?: string;
    hardwareName?: string;
    cabinetType?: number;
    conditionalType?: string;
    conditionalValue?: string;

    hardware: {
        type: HardwareType;
    };
}

export interface Drawer {
    drawer_face_height?: number;
    drawer_style?: number;
    drawer_type?: number;
    id?: number;
    drawer_runner_specs?: string;
    insert_id?: number;
    drawer_runner_height?: number;
    drawer_runner_depth?: number;
    drawer_runner_desc?: string;
    name?: string;
    parts?: Part[];
    hardware?: Hardware[];

    position_to_bottom?: number;
    touched?: boolean;

    systemTopClearance?: number;
    systemBottomClearance?: number;
    systemInnerDrawerBottomClearance?: number;
    insert?: {
        id: number;
    };
}

export type DrawerKey = keyof Drawer;

export interface DrawerFields {
    drawers: Drawer[];
    [key: string]: number | Drawer[];
}
